import { ButtonBase } from '@/shared/ui';

import { SHOW_SELECTED_URL_PARAM } from '@/config/constants';
import { useAppSelector } from '@/store/hooks';

import { useFilter } from '../../state/useFilter';

const buttonSx = {
  border: '1px solid',
  borderColor: 'gx.actionBarButtonTile',
  px: 1,
  height: 34,
  color: 'gx.highlight',
  fontSize: 14,
  fontWeight: 700
};

const activeButtonSx = {
  border: '1px solid transparent',
  backgroundColor: 'gx.highlight',
  color: '#fff'
};

const ShowSelectedSwitch = () => {
  const { filters, setFilter } = useFilter();
  const noneSelected = useAppSelector(state => state.symbolSelector.symbols.length === 0);
  const isChecked = filters[SHOW_SELECTED_URL_PARAM];

  return (
    <ButtonBase
      aria-pressed={isChecked}
      disabled={noneSelected && !isChecked}
      sx={isChecked ? [buttonSx, activeButtonSx] : buttonSx}
      onClick={() => {
        setFilter(SHOW_SELECTED_URL_PARAM, !isChecked);
      }}
    >
      Show selected only
    </ButtonBase>
  );
};

export default ShowSelectedSwitch;
